import { useContext } from 'react';

import { DocumentEditorContext } from '../contexts/documentEditor.context';

export const useDocumentEditor = () => {
    return useContext(DocumentEditorContext);
};
